export type ContactAttachment = {
  filename: string;
  contentType: string;
  size: number;
  contentBase64: string;
};

export type ContactSubmissionInput = {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  message?: string;
  office?: string;
  source?: string;
  page?: string;
  attachments?: ContactAttachment[];
};

export async function submitContactForm(input: ContactSubmissionInput) {
  const response = await fetch("/api/contact", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(typeof data.error === "string" ? data.error : "Could not send message");
  }

  return data as { ok: true };
}
